// Checkout payments allowed in the following countries
// France, India, Spain, South Africa, Sweden, UAE, Singapore, Romania, Malaysia

export const CHECKOUT_ALLOWED_COUNTRIES = [
    "FR",
    "ES",
    "ZA",
    "SE",
    "AE",
    "SG",
    "RO",
    "MY"
]

// Payok payment method is only available in India, Brazil and Colombia
// Country here is the full name as returned by payments/get/profile/ (basicDetails.Country)
// Kept lowercase so callers can compare with .toLowerCase() and avoid case mismatches
export const PAYOK_ALLOWED_COUNTRIES = ["india", "brazil", "colombia"]